export default "__VITE_ASSET__Bw7lpA$o__"